export default "__VITE_ASSET__BBZGEic___"